export default __webpack_public_path__ + "static/contact-bg-ac5dac601872c8b1132508b6934e3006.png";